import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, Table, DLMenu } from 'appSrc/components/UI';
import { CopyDrop } from '../../Common';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import EditArticleModal from '../../Modals/Article/EditArticleModal';
import { parseYouTubeUrl, encodeForURI } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedArticlesTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            articleInEdit: null,
            articleInEditIndex: -1,
        };
    }
    updateArticle =( index, id, data ) => {
        this.props.updateArticle( id, data )
        .then( ( article ) => {
            return this.props.onArticleUpdated && this.props.onArticleUpdated( index, article );
        } );
    }
    openEditModal = ( index, user ) => {
        this.setState( { articleInEdit: user, articleInEditIndex: index } );
    }
    onEditSubmit = ( article ) => {
        var index = this.state.articleInEditIndex;
        this.setState( { articleInEdit: null, articleInEditIndex: -1 } );
        this.props.onArticleUpdated( index, article );
    }
    onEditClose = () => {
        this.setState( { articleInEdit: null, articleInEditIndex: -1 } );
    }

    render() {
        const { articles } = this.props;

        return (
            <div>
                <Table
                className={ style.articlesTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell></Table.Cell>
                            <Table.Cell style={ { minWidth: '100px' } }></Table.Cell>
                            <Table.Cell>LIST NAME</Table.Cell>
                            <Table.Cell>USER</Table.Cell>
                            <Table.Cell>PRODUCTS</Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( articles ) }
                    </Table.SortableBody>
                </Table>
                { this.state.articleInEdit &&
                    <EditArticleModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    article={ this.state.articleInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( articles ) => {
        var rows = articles.map( ( article, index ) => {
            var author = article.author || {};
            var individualSlug = `/admin/content/${ article.id }`;
            var publicSlug = `${ window.location.origin }/app/articles/${ article.id }/${ encodeForURI(article.title) }`;
            return (
                <Table.Row key={ article.id }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inheirit' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <ListCoverImage videoId={ parseYouTubeUrl( article.video_url ) } coverImage={ article.cover_image } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { article.title }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ `/admin/users/${ author.userid }` }></Link>
                        { author.displayName }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { article.desires.length }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, article );
                            } }/>
                            <DLMenu.Item text={ !article.published ? 'Publish' : 'Unpublish' }
                            onClick={ () => {
                                this.updateArticle( index, article.id, {
                                    published: !article.published,
                                    title: article.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ article.featured ? 'Unfeature' : 'Feature' }
                            onClick={ () => {
                                this.updateArticle( index, article.id, {
                                    featured: !article.featured,
                                    title: article.title,
                                } );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
FeaturedArticlesTable.defaultProps = {
    onArticleUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, dAPI.clean.admin.article( data ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedArticlesTable );
